module.exports = __webpack_public_path__ + "img/1_035.fd3afb7b.jpg";